<template>
    <DFormRow
        :label="label"
        :is-required="required"
    >
        <div
            style="display: flex; align-items: center; width: 100%;"
        >
            <VueSelect
                v-model="contractValue"
                input-id="dropdown-parent-contract"
                :multiple="false"
                :close-on-select="true"
                :options="contractList"
                :filterable="false"
                :disabled="disabled"
                :clearable="false"
                @open="onOpen"
                @close="onClose"
                @search="updateSearchText"
                @option:selected="emitValue"
                @option:deselected="emitValue"
            >
                <template #list-footer>
                    <li
                        v-show="hasNextPage"
                        ref="load"
                        class="loader"
                    >
                        {{ __('products.products.form.loading_more_options') }}
                    </li>
                </template>
                <template #no-options="{ searching }">
                    <template v-if="searching">
                        {{ __('products.products.form.no_results') }}
                    </template>
                    <em
                        v-else
                        style="opacity: 0.5"
                    >
                        {{ __('products.products.form.start_typing') }}
                    </em>
                </template>
            </VueSelect>
        </div>
    </DFormRow>
</template>

<script>

import VueSelect from 'vue-select'

export default {
    name: 'ContractParentSelection',
    components: { VueSelect },
    props: {
        customerId: {
            type: Number,
            default: 0
        },
        contractId: {
            type: Number,
            default: 0
        },
        productGroupId: {
            type: Number,
            default: 0
        },
        selectedContract: {
            type: Array,
            default: () => { return [] }
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        label: {
            type: String,
            default: ''
        },
        labelCol: {
            type: String,
            default: '2'
        },
        selectCol: {
            type: String,
            default: '6'
        }
    },
    emits: ['update'],
    data () {
        return {
            contractValue: this.selectedContract.map((contract) => {
                return {
                    label: contract.label,
                    value: contract.value
                }
            }),
            contracts: [],
            observer: null,
            searchText: null,
            currentPage: 1,
            lastPage: 1,
            timeout: null
        }
    },
    computed: {
        hasNextPage () {
            return this.currentPage < this.lastPage
        },
        contractList () {
            return this.contracts
        }
    },
    watch: {
        productGroupId: function () {
            this.fetchContractsInitially()
        }
    },
    mounted () {
        this.observer = new IntersectionObserver(this.appendContracts)
    },
    created () {
        this.fetchContractsInitially()

        if (this.disabled) {
            this.contracts = this.selectedContract
        }
    },
    methods: {
        async onOpen () {
            if (this.hasNextPage) {
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
            }
        },
        onClose () {
            this.observer.disconnect()
        },
        async fetchContractsInitially () {
            this.currentPage = 1

            await this.fetchContracts()
                .then((res) => {
                    this.lastPage = res.data.lastPage
                    this.contracts = [{ value: '', label: this.__('customers.contracts.no_parent'), contract_status: null }, ...(res.data.items ? res.data.items : [])]
                })
        },
        async appendContracts ([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent
                const scrollTop = target.offsetParent.scrollTop

                this.currentPage++

                await this.fetchContracts()
                    .then((res) => {
                        this.contracts = this.contracts.concat(res.data.items)
                    })

                await this.$nextTick()
                ul.scrollTop = scrollTop
            }
        },
        fetchContracts () {
            const params = {
                customer: this.customerId,
                page: this.currentPage
            }

            if (this.searchText) {
                params.query = this.searchText
            }

            if (this.contractId) {
                params.contract = this.contractId
            }

            if (this.productGroupId) {
                params.product_group_id = this.productGroupId
            }

            return window.axios.get(this.$route('customers.dropdown.parent_selection_list', params))
        },
        updateSearchText (query) {
            this.searchText = query

            if (this.timer) {
                clearTimeout(this.timer)

                this.timer = null
            }

            this.timer = setTimeout(() => {
                this.fetchContractsInitially()
            }, 500)
        },
        emitValue () {
            this.$emit('update', this.contractValue)
        }
    }
}
</script>

<style>
:root {
    --vs-selected-color: #5c6873 !important;
    --vs-state-disabled-bg: #e4e7ea !important;
    --vs-border-color: rgb(228, 231, 234) !important;
}
.v-select {
    flex-grow: 1
}
</style>
